import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-golf-line bg-golf-light px-4 py-4" data-id="element-158" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-4xl" data-id="element-159" data-mp="3fym7ekpgr24c">
        <div className="mb-2 text-center" data-id="element-160" data-mp="3fxkx4ig9ujno">
          <h2 className="font-display text-2xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-161" data-mp="3b1cj58dt8wi3">
            What Coaches Are Saying
          </h2>
          <p className="font-head text-[11px] font-semibold uppercase tracking-wide text-golf-gold sm:text-sm" data-id="element-162" data-mp="31zw9j2utkyex">
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews
          </p>
        </div>
        <div className="grid gap-2 sm:grid-cols-2" data-id="element-163" data-mp="2x2mn7w2q92vb">
          {testimonials.map(testimonial => <article key={testimonial.author} className="flex flex-col rounded-lg border border-golf-line bg-white p-3 shadow-sm" data-id="element-164" data-mp="2s430vuk81p2f">
              <div className="mb-1 flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-165" data-mp="qb51tgzuq091">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-golf-gold text-golf-gold" aria-hidden="true" data-id="element-166" data-mp="m51cjvsy5da0" />)}
              </div>
              <p className="mb-2 text-xs font-medium italic leading-snug text-golf-muted sm:text-sm" data-id="element-167" data-mp="c623ic49rfmh">
                “{testimonial.text}”
              </p>
              <div className="mt-auto flex items-center gap-2.5 border-t border-golf-line pt-2" data-id="element-168" data-mp="zysbybcyrgs0">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-golf-green font-head text-sm font-bold text-golf-lime" data-id="element-169" data-mp="14xddqf7v68ik">
                  {testimonial.author.charAt(0)}
                </span>
                <div className="leading-tight" data-id="element-170" data-mp="1ivk131f6sq3z">
                  <p className="font-head text-[13px] font-bold text-golf-green" data-id="element-171" data-mp="1itqshgl0jvtc">
                    {testimonial.author}
                  </p>
                  <p className="text-[10px] font-semibold uppercase tracking-wide text-golf-muted sm:text-[11px]" data-id="element-172" data-mp="1xhquzg0vzcps">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}